// extracted by mini-css-extract-plugin
export default {"signinForm":"SignIn_signinForm__0RvrO","header":"SignIn_header__GKIOv","btn":"SignIn_btn__WYV09","signUpText":"SignIn_signUpText__TG-JW","signUpLink":"SignIn_signUpLink__EbhMy"};